import { render, staticRenderFns } from "./EnvLabel.vue?vue&type=template&id=b760fa94&scoped=true"
import script from "./EnvLabel.vue?vue&type=script&lang=js"
export * from "./EnvLabel.vue?vue&type=script&lang=js"
import style0 from "./EnvLabel.vue?vue&type=style&index=0&id=b760fa94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b760fa94",
  null
  
)

export default component.exports